var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',_vm._g(_vm._b({staticClass:"w-full my-2 py-2 px-4 appearance-none border rounded focus:outline-none focus:border-primary"},'input',_vm.attrs,false),_vm.listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }